import _cloneDeep from "lodash/cloneDeep";
import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import { wrapCollection } from '../common-utils';
import enhanceWithMethods from '../enhance-with-methods';
import errorHandler from '../error-handler';
/**
 * Represents that state of the scheduled action
 */

var ScheduledActionStatus;
(function (ScheduledActionStatus) {
  ScheduledActionStatus["scheduled"] = "scheduled";
  ScheduledActionStatus["inProgress"] = "inProgress";
  ScheduledActionStatus["succeeded"] = "succeeded";
  ScheduledActionStatus["failed"] = "failed";
  ScheduledActionStatus["canceled"] = "canceled";
})(ScheduledActionStatus || (ScheduledActionStatus = {}));
export function createDeleteScheduledAction(http) {
  return function () {
    var self = this;
    return http["delete"]('scheduled_actions/' + self.sys.id).then(function (response) {
      return wrapScheduledAction(http, response.data);
    }, errorHandler);
  };
}
export default function createScheduledActionApi(http) {
  return {
    "delete": createDeleteScheduledAction(http)
  };
}
export function wrapScheduledAction(http, data) {
  var scheduledAction = toPlainObject(_cloneDeep(data));
  var scheduledActionWithMethods = enhanceWithMethods(scheduledAction, createScheduledActionApi(http));
  return freezeSys(scheduledActionWithMethods);
}
export var wrapScheduledActionCollection = wrapCollection(wrapScheduledAction);